import apiCrud from '../../abstract/api-crud';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/crms/agreements/price-increases`;
export const modelName = 'price-increase';

export default {
  ...apiCrud({ baseUri, modelName }),
};
